import { type OpenApiSchemaCategory, type OpenApiSchemaNewCategory } from '#shared/api/schema';
import { createDuplicatedString } from '#shared/lib/string';

export function duplicateCategoryEntity(
    category: OpenApiSchemaCategory,
    categories: OpenApiSchemaCategory[]
): OpenApiSchemaNewCategory {
    const titles: string[] = [];
    let sequence = 0;

    categories.forEach((cat) => {
        titles.push(cat.title);
        sequence = cat.parent_id === category.parent_id ? Math.max(sequence, cat.display_sequence) : sequence;
    });

    return {
        title: createDuplicatedString(category.title, titles),
        parent_id: category.parent_id,
        display_sequence: sequence + 1,
    };
}
